<template>
  <div class="animated fadeIn">
    <b-row class="px-3 mb-4 mt-2">
      <!-- CARD LUCRO -->
      <b-col sm="6" class="col-five mb-4">
        <div class="vibrant-card card-v-lucro" @click.stop.prevent="abrirDetalhesLucro()">
          <div class="vibrant-card__header">
            <div>
              <span class="vibrant-card__label">Lucro Mensal</span>
              <h2 class="vibrant-card__value">{{lucroMesAtualTotal}}</h2>
            </div>
            <div class="vibrant-card__icon"><i class="icon-graph"></i></div>
          </div>
          <div class="vibrant-card__info mt-1">
            <small>Performance Mensal</small>
            <div>Acumulado</div>
          </div>
          <div class="vibrant-card__chart">
            <card-line2-chart-example :height="80" :data="lucroUltimos7DiasDados" :labels="lucroUltimos7DiasTitulos" />
          </div>
        </div>
      </b-col>

      <!-- CARD RECEBER -->
      <b-col sm="6" class="col-five mb-4">
        <div class="vibrant-card card-v-receber" @click.stop.prevent="abrirAreceberProximos10Dias()">
          <div class="vibrant-card__header">
            <div>
              <span class="vibrant-card__label">Receber (10d)</span>
              <h2 class="vibrant-card__value">{{areceber10DiasTotal}}</h2>
            </div>
            <div class="vibrant-card__icon"><i class="icon-clock"></i></div>
          </div>
          <div class="vibrant-card__info mt-1">
            <small>Fluxo de Entrada</small>
            <div>Previsto</div>
          </div>
          <div class="vibrant-card__chart">
            <card-line1-chart-example :height="80" :data="areceber10DiasDados" :labels="areceber10DiasTitulos" />
          </div>
        </div>
      </b-col>

      <!-- CARD RECEBIDO -->
      <b-col sm="6" class="col-five mb-4">
        <div class="vibrant-card card-v-recebido" @click.stop.prevent="abrirRecebidoUltimos10Dias()">
          <div class="vibrant-card__header">
            <div>
              <span class="vibrant-card__label">Recebido (10d)</span>
              <h2 class="vibrant-card__value">{{recebido10DiasTotal}}</h2>
            </div>
            <div class="vibrant-card__icon"><i class="icon-wallet"></i></div>
          </div>
          <div class="vibrant-card__info mt-1">
            <small>Liquidez Real</small>
            <div>Efetivado</div>
          </div>
          <div class="vibrant-card__chart">
            <card-line2-chart-example :height="80" :data="recebido10DiasDados" :labels="recebido10DiasTitulos" />
          </div>
        </div>
      </b-col>

      <!-- CARD PAGO -->
      <b-col sm="6" class="col-five mb-4">
        <div class="vibrant-card card-v-pago" @click.stop.prevent="abrirPagoUltimos10Dias()">
          <div class="vibrant-card__header">
            <div>
              <span class="vibrant-card__label">Pago (10d)</span>
              <h2 class="vibrant-card__value">{{pago10DiasTotal}}</h2>
            </div>
            <div class="vibrant-card__icon"><i class="icon-basket-loaded"></i></div>
          </div>
          <div class="vibrant-card__info mt-1">
            <small>Fluxo de Saída</small>
            <div>Realizado</div>
          </div>
          <div class="vibrant-card__chart">
            <card-line3-chart-example :height="80" :data="pago10DiasDados" :labels="pago10DiasTitulos" />
          </div>
        </div>
      </b-col>

      <!-- CARD APAGAR -->
      <b-col sm="6" class="col-five mb-4">
        <div class="vibrant-card card-v-apagar" @click.stop.prevent="abrirApagarProximos10Dias()">
          <div class="vibrant-card__header">
            <div>
              <span class="vibrant-card__label">A Pagar (10d)</span>
              <h2 class="vibrant-card__value">{{apagar10DiasTotal}}</h2>
            </div>
            <div class="vibrant-card__icon"><i class="icon-speech"></i></div>
          </div>
          <div class="vibrant-card__info mt-1">
            <small>Compromissos</small>
            <div>Pendentes</div>
          </div>
          <div class="vibrant-card__chart">
            <card-bar-chart-example :height="80" :data="apagar10DiasDados" :labels="apagar10DiasTitulos" />
          </div>
        </div>
      </b-col>
    </b-row>

    <lucro-dashboard-modal />
    <operacao-venda-dashboard-modal />


    <b-card :bg-variant="isDark ? 'dark' : ''">
      <b-row>
        <b-col sm="5">
          <h4 id="traffic" class="card-title mb-0">Fluxo de Caixa próximos 20 dias</h4>
          <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Areceber x Apagar</div>
        </b-col>
        <b-col sm="7" class="d-none d-md-block">
          <b-button type="button" @click.stop.prevent="abrirFluxoCaixa10Dias()" variant="primary" class="float-right"><i class="icon-cloud-download"></i></b-button>
          <!--
          <b-button-toolbar class="float-right" aria-label="Toolbar with buttons group">
            <b-form-radio-group class="mr-3" id="radiosBtn" buttons button-variant="outline-secondary" v-model="selected" name="radiosBtn">
              <b-form-radio class="mx-0" value="Day">Day</b-form-radio>
              <b-form-radio class="mx-0" value="Month">Month</b-form-radio>
              <b-form-radio class="mx-0" value="Year">Year</b-form-radio>
            </b-form-radio-group>
          </b-button-toolbar>
          -->
        </b-col>
      </b-row>
      <main-chart-example class="chart-wrapper" style="height:300px;margin-top:40px;" height="300"></main-chart-example>
      <!--
      <div slot="footer">
        <ul>
          <li>
            <div class="text-muted">Visits</div>
            <strong>29.703 Users (40%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="success" :value="40"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">Unique</div>
            <strong>24.093 Users (20%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="info" :value="20"></b-progress>
          </li>
          <li>
            <div class="text-muted">Pageviews</div>
            <strong>78.706 Views (60%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="warning" :value="60"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">New Users</div>
            <strong>22.123 Users (80%)</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" variant="danger" :value="80"></b-progress>
          </li>
          <li class="d-none d-md-table-cell">
            <div class="text-muted">Bounce Rate</div>
            <strong>40.15%</strong>
            <b-progress height={} class="progress-xs mt-2" :precision="1" :value="40"></b-progress>
          </li>
        </ul>
      </div>
      -->
    </b-card>
    <!--
    <b-row>
      <b-col sm="6" lg="3">
        <div class="social-box facebook">
          <i class="fa fa-facebook"></i>
          <div class="chart-wrapper">
            <social-box-chart-example :data="[65, 59, 84, 84, 51, 55, 40]" height="90"/>
          </div>
          <ul>
            <li>
              <strong>89k</strong>
              <span>friends</span>
            </li>
            <li>
              <strong>459</strong>
              <span>feeds</span>
            </li>
          </ul>
        </div>

      </b-col>
      <b-col sm="6" lg="3">
        <div class="social-box twitter">
          <i class="fa fa-twitter"></i>
          <div class="chart-wrapper">
            <social-box-chart-example :data="[1, 13, 9, 17, 34, 41, 38]" height="90"/>
          </div>
          <ul>
            <li>
              <strong>973k</strong>
              <span>followers</span>
            </li>
            <li>
              <strong>1.792</strong>
              <span>tweets</span>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col sm="6" lg="3">
        <div class="social-box linkedin">
          <i class="fa fa-linkedin"></i>
          <div class="chart-wrapper">
            <social-box-chart-example :data="[78, 81, 80, 45, 34, 12, 40]" height="90"/>
          </div>
          <ul>
            <li>
              <strong>500+</strong>
              <span>contacts</span>
            </li>
            <li>
              <strong>292</strong>
              <span>feeds</span>
            </li>
          </ul>
        </div>
      </b-col>
      <b-col sm="6" lg="3">
        <div class="social-box google-plus">
          <i class="fa fa-google-plus"></i>
          <div class="chart-wrapper">
            <social-box-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" height="90"/>
          </div>
          <ul>
            <li>
              <strong>894</strong>
              <span>followers</span>
            </li>
            <li>
              <strong>92</strong>
              <span>circles</span>
            </li>
          </ul>
        </div>
      </b-col>
    </b-row>
    -->
    <b-row>
      <b-col md="12">
        <b-card header="Movimento da Semana" :bg-variant="isDark ? 'dark' : ''">
          <b-row>
            <b-col sm="12" lg="4">
              <b-row>
                <b-col sm="6" @click.stop.prevent="abrirMovimentoPeriodo()" >
                  
                  <Callout variant="info" style="cursor: pointer; " >
                    <small :class="isDark ? 'text-light' : 'text-muted'" >Receitas</small><br>
                    <strong class="h4">{{receitaSemanaTotal}}</strong>
                    <div class="chart-wrapper">
                      <callout-chart-example :data="receitaSemanaDados[0].data" :labels="receitaSemanaTitulos" variant="#20a8d8" width="80" height="30"  />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6" @click.stop.prevent="abrirDespesasPeriodo()" >
                  <Callout variant="danger" style="cursor: pointer; ">
                    <small :class="isDark ? 'text-light' : 'text-muted'">Despesas</small><br>
                    <strong class="h4">{{despesaSemanaTotal}}</strong>
                    <div class="chart-wrapper">
                      <callout-chart-example :data="despesaSemanaDados[0].data" :labels="despesaSemanaTitulos"  variant="#f86c6b" width="80" height="30" />
                    </div>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
              <ul class="horizontal-bars">
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''" >
                    Domingo
                  </div>
                  <div class="bars" >
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[0]" variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" show-value :value="movimentoDiasSemanaDados[0].dataB[0]" variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Segunda
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[1]" variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[1]" variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Terça
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[2]" variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[2]" variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Quarta
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[3]"  variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[3]" variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Quinta
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[4]"  variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[4]"  variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Sexta
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[5]"  variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[5]"  variant="danger"></b-progress>
                  </div>
                </li>
                <li>
                  <div class="title" :class="isDark ? 'text-light' : ''">
                    Sabado
                  </div>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataA[6]"  variant="info"></b-progress>
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="maiorDespesaReceita" :value="movimentoDiasSemanaDados[0].dataB[6]"  variant="danger"></b-progress>
                  </div>
                </li>
                <li class="legend">
                  <b-badge pill variant="info"></b-badge> <small>Receitas</small> &nbsp; <b-badge pill variant="danger"></b-badge> <small>Despesas</small>
                </li>
              </ul>
            </b-col>
            <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="warning">
                    <small :class="isDark ? 'text-light' : 'text-muted'">Compras</small><br>
                    <strong class="h4">{{compraSemanaTotal}}</strong>
                    <div class="chart-wrapper">
                      <callout-chart-example :data="compraSemanaDados[0].data" :labels="compraSemanaTitulos"  variant="#f8cb00" width="80" height="30" />
                    </div>
                  </Callout>
                </b-col>
                <b-col sm="6" @click.stop.prevent="abrirVendasPeriodo()">
                  <Callout variant="success">
                    <small :class="isDark ? 'text-light' : 'text-muted'">Vendas</small><br>
                    <strong class="h4">{{vendaSemanaTotal}}</strong>
                    <div class="chart-wrapper">
                      <callout-chart-example :data="vendaSemanaDados[0].data" :labels="vendaSemanaTitulos" variant="#4dbd74" width="80px" height="30" />
                    </div>
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
              <ul class="horizontal-bars type-2">
                <li>
                  <i class="icon-user"></i>
                  <span class="title">{{vendaMelhoresClientesSemanaDados[0].nome}}</span>
                  <span class="value">{{vendaMelhoresClientesSemanaDados[0].valorReal}} 
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{vendaMelhoresClientesSemanaDados[0].percentual}} </span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="vendaMelhoresClientesSemanaTotal" :value="vendaMelhoresClientesSemanaDados[0].valor" variant="success"></b-progress>
                  </div>
                </li>
                <li>
                  <i class="icon-user"></i>
                   <span class="title">{{vendaMelhoresClientesSemanaDados[1].nome}}</span>
                  <span class="value">{{vendaMelhoresClientesSemanaDados[1].valorReal}} 
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{vendaMelhoresClientesSemanaDados[1].percentual}} </span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''"  :max="vendaMelhoresClientesSemanaTotal" :value="vendaMelhoresClientesSemanaDados[1].valor" variant="success"></b-progress>
                  </div>
                </li>
                <li>
                  <i class="icon-user"></i>
                   <span class="title">{{vendaMelhoresClientesSemanaDados[2].nome}}</span>
                  <span class="value">{{vendaMelhoresClientesSemanaDados[2].valorReal}} 
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{vendaMelhoresClientesSemanaDados[2].percentual}} </span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''"  :max="vendaMelhoresClientesSemanaTotal" :value="vendaMelhoresClientesSemanaDados[2].valor" variant="success"></b-progress>
                  </div>
                </li>
                <li>
                  <i class="icon-user"></i>
                   <span class="title">{{vendaMelhoresClientesSemanaDados[3].nome}}</span>
                  <span class="value">{{vendaMelhoresClientesSemanaDados[3].valorReal}} 
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{vendaMelhoresClientesSemanaDados[3].percentual}} </span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''" :max="vendaMelhoresClientesSemanaTotal" :value="vendaMelhoresClientesSemanaDados[3].valor" variant="success"></b-progress>
                  </div>
                </li>
                <li class="divider"></li>
                <li>
                  <i class="icon-user"></i>
                  <span class="title">{{compraMelhoresFornecedoresSemanaDados[0].nome}}</span>
                  <span class="value">{{compraMelhoresFornecedoresSemanaDados[0].valorReal}}  
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{compraMelhoresFornecedoresSemanaDados[0].percentual}}</span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''"  :max="compraMelhoresFornecedoresSemanaTotal" :value="compraMelhoresFornecedoresSemanaDados[0].valor" variant="warning"></b-progress>
                  </div>
                </li>
                <li>
                  <i class="icon-user"></i>
                  <span class="title">{{compraMelhoresFornecedoresSemanaDados[1].nome}}</span>
                  <span class="value">{{compraMelhoresFornecedoresSemanaDados[1].valorReal}}  
                    <span class="small"  :class="isDark ? 'text-light' : 'text-muted'">{{compraMelhoresFornecedoresSemanaDados[1].percentual}}</span></span>
                  <div class="bars">
                    <b-progress height={} class="progress-xs" :class="isDark ? 'bg-gray-700 text-light' : ''"  :max="compraMelhoresFornecedoresSemanaTotal" :value="compraMelhoresFornecedoresSemanaDados[1].valor" variant="warning"></b-progress>
                  </div>
                </li>
                <li class="legend">
                  <b-badge pill variant="warning"></b-badge> <small>Melhores Fornecedores</small> &nbsp; <b-badge pill variant="success"></b-badge> <small>Melhores Clientes</small>
                </li>
                <!-- Reticencias
                <li class="divider text-center">
                  <b-button variant="link" size="sm" class="text-muted"><i class="icon-options"></i></b-button>
                </li>
                -->
              </ul>
            </b-col>
            <b-col sm="6" lg="4">
              <b-row>
                <b-col sm="6">
                  <Callout variant="green" >
                    <small :class="isDark ? 'text-light' : 'text-muted'">RECEBIDO HOJE</small><br>
                    <strong class="h4" @click.stop.prevent="abrirRecebidoHoje()" >{{totalRecebidoHoje}}</strong>
                    <!--
                    <div class="chart-wrapper">
                      <callout-chart-example :data="[78, 81, 80, 45, 34, 12, 40]" width="80px" height="30" />
                    </div>
                    -->
                  </Callout>
                </b-col>
                <b-col sm="6">
                  <Callout variant="red" >
                    <small :class="isDark ? 'text-light' : 'text-muted'">PAGO HOJE</small><br>
                    <strong class="h4" @click.stop.prevent="abrirPagoHoje()">{{totalPagoHoje}}</strong>
                    <!--
                    <div class="chart-wrapper">
                      <callout-chart-example :data="[35, 23, 56, 22, 97, 23, 64]" variant="#20a8d8" width="80px" height="30" />
                    </div>
                    -->
                  </Callout>
                </b-col>
              </b-row>
              <hr class="mt-0">
              <ul class="icons-list">
                <li>
                  <i class="icon-basket-loaded bg-primary"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[0].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'" >Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[0].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-info"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[1].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[1].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-warning"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[2].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[2].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-danger"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[3].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[3].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-success"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[4].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[4].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-danger"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[5].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[5].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li>
                  <i class="icon-basket-loaded bg-warning"></i>
                  <div class="desc">
                    <div class="title">{{vendaMelhoresProdutosSemanaDados[6].nome}}</div>
                    <small  :class="isDark ? 'text-light' : 'text-muted'">Produto em Estoque</small>
                  </div>
                  <div class="value">
                    <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Nessa semana</div>
                    <strong>{{vendaMelhoresProdutosSemanaDados[6].valorReal}}</strong>
                  </div>
                  <div class="actions">
                    <b-button variant="link" class="text-muted"><i class="icon-settings"></i></b-button>
                  </div>
                </li>
                <li class="divider text-center">
                  <b-button size="sm" variant="link"  :class="isDark ? 'text-light' : 'text-muted'" >Ordenados pelo Valor </b-button>
                </li>
              </ul>
            </b-col>
          </b-row>
          <br/>
          
          <!-- Link para Painel de Cancelamentos -->
          <b-row class="mb-3">
            <b-col>
              <b-button 
                variant="outline-warning" 
                block 
                @click="abrirPainelCancelamentos()" 
                class="d-flex align-items-center justify-content-center"
              >
                <i class="fa fa-exclamation-triangle mr-2"></i>
                <strong>Painel de Cancelamentos e Alterações</strong>
              </b-button>
            </b-col>
          </b-row>
          
          <b-table  class="mb-0 table-outline" 
                    responsive="sm" 
                    hover 
                    :items="tableContasItems" 
                    :fields="tableContasFields" 
                    :head-variant="isDark ? 'dark' : 'light'"
                    :dark="isDark"
                    @row-clicked="myRowClickHandler">
            <!--
            <template #cell(avatar)="item" >
              <img :src="item.value.url" class="img-avatar" alt="">
              <span class="avatar-status" v-bind:class="{ 'bg-info': item.value.status == 'info', 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
            </div>
            -->
            <template #cell(conta)="item" >
              <div>
                <strong>{{item.value.banco}}</strong>
              </div>
              <div class="small" :class="isDark ? 'text-light' : 'text-muted'">
                <span>
                  
                  Conta: {{item.value.conta}}
                </span>
              </div>
            </template>
            <template #cell(boleto)="boleto" >
              <div>
                <strong>{{boleto.item.boleto}}</strong>
              </div>
              
            </template>
            <template #cell(total)="total" >
              <div>
                <strong>{{total.item.total}}</strong>
              </div>
              
            </template>
            
          </b-table>
          <!--
          <b-table class="mb-0 table-outline" responsive="sm" hover :items="tableItems" :fields="tableFields" head-variant="light">
            <div slot="avatar" class="avatar" slot-scope="item">
              <img :src="item.value.url" class="img-avatar" alt="">
              <span class="avatar-status" v-bind:class="{ 'bg-success': item.value.status == 'success',  'bg-warning': item.value.status == 'warning', 'bg-danger': item.value.status == 'danger', 'bg-secondary': item.value.status == '' }"></span>
            </div>
            <div slot="user" slot-scope="item">
              <div>{{item.value.name}}</div>
              <div class="small" :class="isDark ? 'text-light' : 'text-muted'">
                <span>
                  <template v-if="item.value.new">New</template>
                  <template v-else>Recurring</template>
                </span> | Registered: {{item.value.registered}}
              </div>
            </div>
            <i slot="country" class="h4 mb-0" :class="flag(item.value.flag)" slot-scope="item" :title="item.value.flag" :id="item.value.flag"></i>
            <i class="flag-icon flag-icon-pw h1" title="pw" id="pw"></i>
            <div slot="usage" slot-scope="item">
              <div class="clearfix">
                <div class="float-left">
                  <strong>{{item.value.value}}%</strong>
                </div>
                <div class="float-right">
                  <small class="text-muted">{{item.value.period}}</small>
                </div>
              </div>
              <b-progress height={} class="progress-xs" v-model="item.value.value" :variant="variant(item.value.value)"></b-progress>
            </div>
            <i slot="payment" slot-scope="item" :class="item.value.icon" style="font-size:24px"></i>
            <div slot="activity" slot-scope="item">
              <div class="small" :class="isDark ? 'text-light' : 'text-muted'">Last login</div>
              <strong>{{item.value}}</strong>
            </div>
          </b-table>
          -->
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import CardLine1ChartExample from './dashboard/CardLine1ChartExample'
import CardLine2ChartExample from './dashboard/CardLine2ChartExample'
import CardLine3ChartExample from './dashboard/CardLine3ChartExample'
import CardBarChartExample from './dashboard/CardBarChartExample'
import MainChartExample from './dashboard/MainChartExample'
import SocialBoxChartExample from './dashboard/SocialBoxChartExample'
import CalloutChartExample from './dashboard/CalloutChartExample'
import LucroDashboardModal from './dashboard/LucroDashboardModal'
import OperacaoVendaDashboardModal from './dashboard/OperacaoVendaDashboardModal'
import { Callout } from '../components/'


export default {
  name: 'dashboard',
  components: {
    Callout,
    CardLine1ChartExample,
    CardLine2ChartExample,
    CardLine3ChartExample,
    CardBarChartExample,
    MainChartExample,
    SocialBoxChartExample,
    CalloutChartExample,
    LucroDashboardModal,
    OperacaoVendaDashboardModal
  },
  data: function () {
    return {
      lucroMesAtualTotal: 0,
      lucroUltimos7DiasTitulos: [],
      lucroUltimos7DiasDados: [
        {
          label: 'Lucro R$:',
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.6)',
          data: []
        }
      ],
      lucroMensalDetalhado: [],
      
      areceber10DiasTotal: 0,
      areceber10DiasTitulos: [],
      areceber10DiasDados: [
        {
          label: 'Valor R$:',
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.6)',
          data: []
        }
      ],

      recebido10DiasTotal: 0,
      recebido10DiasTitulos: [],
      recebido10DiasDados: [
        {
          label: 'Valor R$:',
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.6)',
          data: []
        }
      ],

      pago10DiasTotal: 0,
      pago10DiasTitulos: [],
      pago10DiasDados: [
        {
          label: 'Valor R$:',
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.6)',
          data: []
        }
      ],

      apagar10DiasTotal: 0,
      apagar10DiasTitulos: [],
      apagar10DiasDados: [
        {
          label: 'Valor R$:',
          backgroundColor: 'rgba(255,255,255,.2)',
          borderColor: 'rgba(255,255,255,.6)',
          data: []
        }
      ],

      despesaSemanaTotal: 0,
      despesaSemanaTitulos: [],
      despesaSemanaDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: []
        }
      ],

      receitaSemanaTotal: 0,
      receitaSemanaTitulos: [],
      receitaSemanaDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: []
        }
      ],

      totalRecebidoHoje: 0.00,
      totalPagoHoje: 0.00,
      
      compraSemanaTotal: 0,
      compraSemanaTitulos: [],
      compraSemanaDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: []
        }
      ],

      vendaSemanaTotal: 0,
      vendaSemanaTitulos: [],
      vendaSemanaDados: [
        {
          label: 'Valor R$:',
          backgroundColor: '#20a8d8',
          borderColor: 'rgba(255,255,255,.55)',
          data: []
        }
      ],

      movimentoDiasSemanaDados: [
        {
          dataA: [],
          dataB: []
        }
      ],
      vendaMelhoresClientesSemanaDados: [
        { nome: '', valor: 0, percentual: '()%', valorReal: '' },
        { nome: '', valor: 0, percentual: '()%', valorReal: '' },
        { nome: '', valor: 0, percentual: '()%', valorReal: '' },
        { nome: '', valor: 0, percentual: '()%', valorReal: '' }
      ],
      vendaMelhoresClientesSemanaTotal: 1000,

      compraMelhoresFornecedoresSemanaDados: [
        { nome: '', valor: 0, percentual: '()%', valorReal: '' },
        { nome: '', valor: 0, percentual: '()%', valorReal: '' }
      ],
      compraMelhoresFornecedoresSemanaTotal: 1000,

      vendaMelhoresProdutosSemanaDados: [
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' },
        { nome: '', valor: 0, valorReal: '' }
      ],
      maiorDespesaReceita: 1000,
      selected: 'Month',
      /*
      tableItems: [
        {
          avatar: { url: 'static/img/avatars/1.jpg', status: 'success' },
          user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'USA', flag: 'us' },
          usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Mastercard', icon: 'fa fa-cc-mastercard' },
          activity: '10 sec ago'
        },
        {
          avatar: { url: 'static/img/avatars/2.jpg', status: 'danger' },
          user: { name: 'Avram Tarasios', new: false, registered: 'Jan 1, 2015' },
          country: { name: 'Brazil', flag: 'br' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Visa', icon: 'fa fa-cc-visa' },
          activity: '5 minutes ago'
        },
        {
          avatar: { url: 'static/img/avatars/3.jpg', status: 'warning' },
          user: { name: 'Quintin Ed', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'India', flag: 'in' },
          usage: { value: 74, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Stripe', icon: 'fa fa-cc-stripe' },
          activity: '1 hour ago'
        },
        {
          avatar: { url: 'static/img/avatars/4.jpg', status: '' },
          user: { name: 'Enéas Kwadwo', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'France', flag: 'fr' },
          usage: { value: 98, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'PayPal', icon: 'fa fa-paypal' },
          activity: 'Last month'
        },
        {
          avatar: { url: 'static/img/avatars/5.jpg', status: 'success' },
          user: { name: 'Agapetus Tadeáš', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Spain', flag: 'es' },
          usage: { value: 22, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Google Wallet', icon: 'fa fa-google-wallet' },
          activity: 'Last week'
        },
        {
          avatar: { url: 'static/img/avatars/6.jpg', status: 'danger' },
          user: { name: 'Friderik Dávid', new: true, registered: 'Jan 1, 2015' },
          country: { name: 'Poland', flag: 'pl' },
          usage: { value: 43, period: 'Jun 11, 2015 - Jul 10, 2015' },
          payment: { name: 'Amex', icon: 'fa fa-cc-amex' },
          activity: 'Last week'
        }
      ],
      tableFields: {
        avatar: {
          label: '<i class="icon-people"></i>',
          class: 'text-center'
        },
        user: {
          label: 'User'
        },
        country: {
          label: 'Country',
          class: 'text-center'
        },
        usage: {
          label: 'Usage'
        },
        payment: {
          label: 'Payment method',
          class: 'text-center'
        },
        activity: {
          label: 'Activity'
        }
      }
      */
      tableContasItems: [
        {
          conta: { banco: 'Banco Bradesco', conta: '12345' },
          boleto:  0 ,
          total: 0
        }
      ],
      tableContasFields: [
        { 
          key: 'conta',
          label: 'Conta'
        },
        { 
          key: 'boleto',
          label: 'Boletos',
          class:'text-right'
        },
        { 
          key: 'total',
          label: 'TOTAL R$:',
          class:'text-right'
        }
      ]
    }
  },
  methods: {
    variant (value) {
      let $variant
      if (value <= 25) {
        $variant = 'info'
      } else if (value > 25 && value <= 50) {
        $variant = 'success'
      } else if (value > 50 && value <= 75) {
        $variant = 'warning'
      } else if (value > 75 && value <= 100) {
        $variant = 'danger'
      }
      return $variant
    },
    variantConta (value) {
      let $variant
      if (value < 0) {
        $variant = 'danger'
      } else {
        $variant = 'success'
      }
      return $variant
    },
    flag (value) {
      return 'flag-icon flag-icon-' + value
    },
    numberToReal (numero) {
      let n = numero.toFixed(2).split('.')
      n[0] = 'R$ ' + n[0].split(/(?=(?:...)*$)/).join('.')
      return n.join(',')
    },
    totalizarRecebidoHoje () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/recebido/totalizarHoje')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.totalRecebidoHoje = this.numberToReal(data.data[0].VALOR_RECEBIDO)
        }
      })
    },
    totalizarPagoHoje () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/pago/totalizarHoje')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.totalPagoHoje = this.numberToReal(data.data[0].VALOR_PAGO)
        }
      })
    },
    totalizarAreceberProximos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/areceber/totalizarproximos10Dias')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.areceber10DiasTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    totalizarRecebidoUltimos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/recebido/totalizarultimos10Dias')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.recebido10DiasTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    totalizarApagarProximos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagar/totalizarproximos10Dias')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.apagar10DiasTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    totalizarPagoUltimos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/pago/totalizarultimos10Dias')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.pago10DiasTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    totalizarDespesasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/totalizardespesassemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.despesaSemanaTotal = this.numberToReal(data.data[0].VALOR)
          this.maiorDespesaReceita += (this.maiorDespesaReceita < data.data[0].VALOR) ? data.data[0].VALOR : this.maiorDespesaReceita
        }
      })
    },
    listarDespesasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/listardespesassemana')
      let promise = this.$http.get(uri)
      this.despesaSemanaDados[0].data = []
      this.despesaSemanaTitulos = []
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.despesaSemanaDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.despesaSemanaTitulos = titulos
        }
      })
    },
    totalizarReceitasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/totalizarreceitassemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.receitaSemanaTotal = this.numberToReal(data.data[0].VALOR)
          this.maiorDespesaReceita += (this.maiorDespesaReceita < data.data[0].VALOR) ? data.data[0].VALOR : this.maiorDespesaReceita
        }
      })
    },
    listarReceitasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/listarreceitassemana')
      let promise = this.$http.get(uri)
      this.receitaSemanaDados[0].data = []
      this.receitaSemanaTitulos = []
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.receitaSemanaDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.receitaSemanaTitulos = titulos
        }
      })
    },
    listarAreceberProximos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/areceber/listarproximos10dias')
      let promise = this.$http.get(uri)
      this.areceber10DiasDados[0].data = []
      this.areceber10DiasTitulos = []
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.areceber10DiasDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.areceber10DiasTitulos = titulos
        }
      })
    },
    listarRecebidoUltimos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/recebido/listarultimos10dias')
      let promise = this.$http.get(uri)
      this.recebido10DiasDados[0].data = []
      this.recebido10DiasTitulos = []
      return promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.recebido10DiasDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.recebido10DiasTitulos = titulos
        }
      })
    },
    listarPagoUltimos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/pago/listarultimos10dias')
      let promise = this.$http.get(uri)
      this.pago10DiasDados[0].data = []
      this.pago10DiasTitulos = []
      return promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.pago10DiasDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.pago10DiasTitulos = titulos
        }
      })
    },
    listarApagarProximos10Dias () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/apagar/listarproximos10dias')
      let promise = this.$http.get(uri)
      this.apagar10DiasDados[0].data = []
      this.apagar10DiasTitulos = []
      return promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.apagar10DiasDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.apagar10DiasTitulos = titulos
        }
      })
    },
    listarComprasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/compra/listarcomprassemana')
      let promise = this.$http.get(uri)
      this.compraSemanaDados[0].data = []
      this.compraSemanaTitulos = []
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.compraSemanaDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.compraSemanaTitulos = titulos
        }
      })
    },
    totalizarComprasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/compra/totalizarcomprassemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.compraSemanaTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    listarVendasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/venda/listarvendassemana')
      let promise = this.$http.get(uri)
      this.vendaSemanaDados[0].data = []
      this.vendaSemanaTitulos = []
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          for (i = 0; i < data.data.length; i++) {
            this.vendaSemanaDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.vendaSemanaTitulos = titulos
        }
      })
    },
    totalizarVendasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/venda/totalizarvendassemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          this.vendaSemanaTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    listarVendasMelhoresClientesSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/venda/listarmelhoresdasemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.vendaMelhoresClientesSemanaDados[i].nome = data.data[i].NOME.substr(0, 20)
            this.vendaMelhoresClientesSemanaDados[i].valor = data.data[i].TOTAL
            this.vendaMelhoresClientesSemanaDados[i].percentual = '()%'
            this.vendaMelhoresClientesSemanaDados[i].valorReal = this.numberToReal(data.data[i].TOTAL)
            this.vendaMelhoresClientesSemanaTotal += data.data[i].TOTAL
          }
        }
      })
    },
    listarComprasMelhoresFornecedoresSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/compra/listarmelhoresdasemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.compraMelhoresFornecedoresSemanaDados[i].nome = data.data[i].NOME.substr(0, 20)
            this.compraMelhoresFornecedoresSemanaDados[i].valor = data.data[i].TOTAL
            this.compraMelhoresFornecedoresSemanaDados[i].percentual = '()%'
            this.compraMelhoresFornecedoresSemanaDados[i].valorReal = this.numberToReal(data.data[i].TOTAL)
            this.compraMelhoresFornecedoresSemanaTotal += data.data[i].TOTAL
          }
        }
      })
    },
    listarVendasMelhoresProdutosSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/venda/listarmelhoresprodutosdasemana')
      let promise = this.$http.get(uri)
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.vendaMelhoresProdutosSemanaDados[i].nome = data.data[i].DESCRICAO.substr(0, 20)
            this.vendaMelhoresProdutosSemanaDados[i].valor = data.data[i].TOTAL
            this.vendaMelhoresProdutosSemanaDados[i].valorReal = this.numberToReal(data.data[i].TOTAL)
          }
        }
      })
    },
    listarMovimentoDiasSemana () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/listardiassemana')
      let promise = this.$http.get(uri)
      this.movimentoDiasSemanaDados[0].dataA = []
      this.movimentoDiasSemanaDados[0].dataB = []
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.movimentoDiasSemanaDados[0].dataA.push(data.data[i].VALORA)
            this.movimentoDiasSemanaDados[0].dataB.push(data.data[i].VALORB)
          }
        }
      })
    },
    listarBoletos () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/boleto/getAbertos')
      let promise = this.$http.get(uri)
      this.tableContasItems = []
      promise.then((data) => {
        if (data) {
          let i
          for (i = 0; i < data.data.length; i++) {
            this.tableContasItems.push({
              conta:         { banco: data.data[i].SIGLA, conta: data.data[i].CODIGO },
              boleto: data.data[i].BOLETOS ,
              total:   this.numberToReal(data.data[i].TOTAL) ,
            })
            // titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          // this.areceber10DiasTitulos = titulos
        }
      })
    },
    listarSaldoContas () {
      let uri = this.$http.defaults.baseURL.concat('api/protected/caixa/listarsaldocontas')
      let promise = this.$http.get(uri)
      this.tableContasItems = []
      promise.then((data) => {
        if (data) {
          let i
          /*
          let item = {
            avatar: { url: '', status: 'success' },
            user: { name: 'Yiorgos Avraamu', new: true, registered: 'Jan 1, 2015' },
            usage: { value: 50, period: 'Jun 11, 2015 - Jul 10, 2015' },
            activity: '10 sec ago'
          }
          */
          for (i = 0; i < data.data.length; i++) {
            this.tableContasItems.push({
              contaid: {value: data.data[i].CONTA_ID},
              avatar: {url: '', status: this.variantConta(data.data[i].VL_SALDO_ATUAL)},
              conta: { banco: data.data[i].NOME_BANCO, conta: data.data[i].NOME_CONTA },
              saldoAnterior: { value: this.numberToReal(data.data[i].VL_SALDO_ANTERIOR) },
              entradas: { value: this.numberToReal(data.data[i].VL_CREDITO), percentual: data.data[i].PERCENTUAL_CREDITO },
              saidas: { value: this.numberToReal(data.data[i].VL_DEBITO), percentual: data.data[i].PERCENTUAL_DEBITO },
              saldoAtual: { value: this.numberToReal(data.data[i].VL_SALDO_ATUAL) }
            })
            // titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          // this.areceber10DiasTitulos = titulos
        }
      })
    },
    abrirAreceberProximos10Dias (item) {
      this.$router.push(`/dashboard/painelgerencial/areceberproximosdezdias`)
    },
    abrirPagoHoje (item) {
      this.$router.push(`/dashboard/painelgerencial/pagoHoje`)
    },
    abrirRecebidoHoje (item) {
      this.$router.push(`/dashboard/painelgerencial/recebidoHoje`)
    },
    abrirApagarProximos10Dias (item) {
      this.$router.push(`/dashboard/painelgerencial/apagarproximosdezdias`)
    },
    abrirPagoUltimos10Dias (item) {
      this.$router.push(`/dashboard/painelgerencial/pagoultimosdezdias`)
    },
    abrirRecebidoUltimos10Dias (item) {
      this.$router.push(`/dashboard/painelgerencial/recebidoultimosdezdias`)
    },
    abrirFluxoCaixa10Dias (item) {
      this.$router.push(`/dashboard/painelgerencial/fluxocaixadezdias`)
    },
    abrirMovimentoPeriodo (item) {
      this.$router.push(`/dashboard/painelgerencial/movimentoperiodo`)
    },
    abrirDespesasPeriodo (item) {
      this.$router.push(`/dashboard/painelgerencial/despesasperiodo`)
    },
    abrirPainelCancelamentos () {
      this.$router.push('/dashboard/painelgerencial/painel-cancelamentos')
    },
    abrirVendasPeriodo (item) {
      this.$bvModal.show('modal-operacao-vendas-dashboard')
    },
    myRowClickHandler (record, index) {
      this.$router.push(`/dashboard/painelgerencial/caixamovimentodia/${record.contaid.value}`)
    },
    totalizarLucroMesAtual () {
      let promise = this.$http.get('api/protected/venda/totalizarLucroMesAtual')
      promise.then((data) => {
        if (data) {
          this.lucroMesAtualTotal = this.numberToReal(data.data[0].VALOR)
        }
      })
    },
    listarLucroUltimos7Dias () {
      let promise = this.$http.get('api/protected/venda/listarLucroUltimos7Dias')
      promise.then((data) => {
        if (data) {
          let i
          let titulos = []
          this.lucroUltimos7DiasDados[0].data = []
          for (i = 0; i < data.data.length; i++) {
            this.lucroUltimos7DiasDados[0].data.push(data.data[i].VALOR)
            titulos.push(new Date(data.data[i].DATA).toISOString().substr(0, 10).split('-').reverse().join('/'))
          }
          this.lucroUltimos7DiasTitulos = titulos
        }
      })
    },
    detalharLucroMensal () {
      return this.$http.get('api/protected/venda/detalharLucroMensal').then((res) => {
        this.lucroMensalDetalhado = res.data
      })
    },
    abrirDetalhesLucro () {
      this.$bvModal.show('modal-lucro-dashboard')
    }
  },
  created () {
    this.listarAreceberProximos10Dias()
    this.listarRecebidoUltimos10Dias()
    this.listarPagoUltimos10Dias()
    this.listarApagarProximos10Dias()
    this.totalizarAreceberProximos10Dias()
    this.totalizarRecebidoHoje()
    this.totalizarPagoHoje()
    this.totalizarRecebidoUltimos10Dias()
    this.totalizarApagarProximos10Dias()
    this.totalizarPagoUltimos10Dias()
    this.listarDespesasSemana()
    this.totalizarDespesasSemana()
    this.listarReceitasSemana()
    this.totalizarReceitasSemana()
    this.listarComprasSemana()
    this.totalizarComprasSemana()
    this.listarVendasSemana()
    this.totalizarVendasSemana()
    this.listarMovimentoDiasSemana()
    this.listarVendasMelhoresClientesSemana()
    this.listarComprasMelhoresFornecedoresSemana()
    this.listarVendasMelhoresProdutosSemana()
    //this.listarSaldoContas()
    this.listarBoletos()
    this.totalizarLucroMesAtual()
    this.listarLucroUltimos7Dias()
  },
  computed: {
    isDark() {
      return this.$store.getters['tema/IS_DARK'] 
    },
  }
}
</script>

<style scoped>
.vibrant-card {
  position: relative;
  height: 180px;
  border-radius: 2px;
  padding: 1.25rem;
  overflow: hidden;
  cursor: pointer;
  transition: all 0.3s ease;
  box-shadow: 0 4px 15px rgba(0,0,0,0.1);
  display: flex;
  flex-direction: column;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.vibrant-card:hover {
  transform: translateY(-5px);
  box-shadow: 0 15px 30px rgba(0,0,0,0.15);
  filter: brightness(1.1);
}

.vibrant-card__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  z-index: 2;
}

.vibrant-card__label {
  display: block;
  font-size: 0.8rem;
  font-weight: 700;
  color: #ffffff;
  margin-bottom: 2px;
  text-shadow: 0 1px 3px rgba(0,0,0,0.2);
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.vibrant-card__value {
  font-size: 1.7rem;
  font-weight: 800;
  color: #ffffff;
  margin: 0;
  letter-spacing: -0.5px;
  text-shadow: 0 2px 5px rgba(0,0,0,0.2);
}

.vibrant-card__icon {
  font-size: 2.5rem;
  color: #ffffff;
  opacity: 0.6;
  filter: drop-shadow(0 2px 4px rgba(0,0,0,0.2));
  transition: all 0.3s ease;
}

.vibrant-card:hover .vibrant-card__icon {
  opacity: 0.9;
  transform: scale(1.1);
}

.vibrant-card__info {
  z-index: 2;
  color: #ffffff;
  margin-top: 8px;
}

.vibrant-card__info small {
  opacity: 0.9;
  font-size: 0.65rem;
  text-transform: uppercase;
  font-weight: 800;
}

.vibrant-card__info div {
  font-weight: 700;
  font-size: 0.9rem;
  text-shadow: 0 1px 3px rgba(0,0,0,0.2);
}

.vibrant-card__chart {
  position: absolute;
  bottom: -5px;
  left: 0;
  right: 0;
  height: 80px;
  z-index: 1;
  opacity: 0.9;
}

/* Crystal Gradient Colors with Requested Palette */
.card-v-lucro { background: linear-gradient(135deg, rgba(16, 185, 129, 0.75) 0%, rgba(5, 150, 105, 0.9) 100%); }   /* Green */
.card-v-receber { background: linear-gradient(135deg, rgba(59, 130, 246, 0.75) 0%, rgba(29, 78, 216, 0.9) 100%); } /* Blue */
.card-v-recebido { background: linear-gradient(135deg, rgba(250, 204, 21, 0.75) 0%, rgba(202, 138, 4, 0.9) 100%); } /* Yellow */
.card-v-pago { background: linear-gradient(135deg, rgba(251, 146, 60, 0.75) 0%, rgba(234, 88, 12, 0.9) 100%); }    /* Light Orange */
.card-v-apagar { background: linear-gradient(135deg, rgba(239, 68, 68, 0.75) 0%, rgba(185, 28, 28, 0.9) 100%); }   /* Red */

/* Grid layout (Mantendo as 5 colunas) */
.col-five {
  position: relative;
  width: 100%;
  flex: 0 0 100%;
  max-width: 100%;
}

@media (min-width: 576px) {
  .col-five { flex: 0 0 50%; max-width: 50%; }
}

@media (min-width: 992px) {
  .col-five { flex: 0 0 33.333333%; max-width: 33.333333%; }
}

@media (min-width: 1200px) {
  .col-five { flex: 0 0 20%; max-width: 20%; }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard.vue